import {IContextLayerQuery} from "./context-layer-query";
import {L} from "../../lt-ng/landcare-toolkit";
import WFSLayer = L.util.WFSLayer;
import {LTServices} from "../../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {Coordinate} from "ol/coordinate";
import {Feature} from "ol";
import {GeoJSON} from "ol/format";
import {Geometry} from "ol/geom";

export class WFSLayerQuery implements IContextLayerQuery {
    constructor(protected wfsLayer: WFSLayer,
                protected $http: ng.IHttpService,
                protected mapService: IMapService,
                protected sourceLayerId: number) {

    }

    queryPointProperties(coordinate: Coordinate, propertyName: string[], cache: boolean = true): ng.IPromise<Array<any>> {
        return this.$http.get(this.wfsLayer.url, {
            params: {
                SERVICE: 'WFS',
                VERSION: this.wfsLayer.wfsVersion,
                REQUEST: 'GetFeature',
                map: this.wfsLayer.map,
                TYPENAME: this.wfsLayer.typename,
                outputFormat: 'json',
                propertyName: propertyName.join(','),
                filter: `<Filter><Intersects><PropertyName>the_geom</PropertyName><gml:Point><gml:coordinates>${coordinate[0]} ${coordinate[1]}</gml:coordinates></gml:Point></Intersects></Filter>`
            },
            cache
        }).then((resp) => {
            return resp.data['features'] || [];
        });
    }

    get featureName(): string {
        return this.wfsLayer.featureName;
    }

    get titleProperty(): string {
        return this.wfsLayer.titleProperty;
    }

    queryPoint(coordinate: Coordinate): ng.IPromise<Array<Feature<Geometry>>> {
        const fes = this.wfsLayer.wfsVersion === '1.0.0' ? '' : 'fes:';
        const nameSpaces = this.wfsLayer.wfsVersion === '1.0.0' ? '' : ` xmlns:fes="http://www.opengis.net/fes/2.0" xmlns:gml="http://www.opengis.net/gml/3.2"`;

        const intersects = `<${fes}Intersects><${fes}PropertyName>the_geom</${fes}PropertyName><gml:Point><gml:coordinates>${coordinate[0]} ${coordinate[1]}</gml:coordinates></gml:Point></${fes}Intersects>`;
        let filter;
        if (this.wfsLayer.extraOgcFilter) {
            filter = `<${fes}Filter${nameSpaces}><${fes}And>${intersects}${this.wfsLayer.extraOgcFilter}</${fes}And></${fes}Filter>`;
        } else {
            filter = `<${fes}Filter${nameSpaces}>${intersects}</${fes}Filter>`;
        }

        return this.$http.get(this.wfsLayer.url, {
            params: {
                SERVICE: 'WFS',
                VERSION: this.wfsLayer.wfsVersion,
                // VERSION: '1.0.0',
                REQUEST: 'GetFeature',
                map: this.wfsLayer.map,
                TYPENAME: this.wfsLayer.typename,
                outputFormat: 'json',
                filter//: `<Filter><Intersects><PropertyName>the_geom</PropertyName><gml:Point><gml:coordinates>${coordinate[0]} ${coordinate[1]}</gml:coordinates></gml:Point></Intersects></Filter>`
            }
        }).then((resp) => {
            let format = new GeoJSON();
            let rawFeatures = resp.data['features'] || [];

            let result = rawFeatures.map((gj) => format.readFeature(gj,{
                dataProjection: 'EPSG:4326',
                featureProjection: this.mapService.map.getView().getProjection()
            }));

            result.forEach((f) => {
                f.set('wfsLayer', this.wfsLayer);
                f.set('sourceLayerId', this.sourceLayerId);
                f.set('_title', f.get(this.wfsLayer && this.wfsLayer.titleProperty));
            });

            return result;
        });
    }
}